import React from 'react'

const StateTab = ({ id, humanReadableName, selectedTabId, states, onChange, disabled }) => (
  <li
    aria-disabled={disabled}
    aria-selected={selectedTabId === id}
    className="bp5-tab"
    onClick={() => {
      if (!disabled) onChange(id, states)
    }}
    role="tab"
    key={id}
  >
    {humanReadableName}
  </li>
)

const StateTabSection = ({ title, disabled, tabs, onChange, selectedTabId }) => (
  <span className="bp5-tab-list" role="tablist" key={title}>
    <h4 style={{ margin: '0 15px', alignSelf: 'center' }}>{title}</h4>
    {tabs.map(t => (
      <StateTab disabled={disabled} key={t.id} onChange={onChange} selectedTabId={selectedTabId} {...t} />
    ))}
  </span>
)

const StateSwitcher = ({ sections, onChange, disabled, selectedTabId, ...rest }) => (
  <div className="bp5-tabs" style={{ display: 'flex' }} {...rest}>
    {sections.map(section => (
      <StateTabSection
        key={section.title}
        disabled={disabled}
        onChange={onChange}
        selectedTabId={selectedTabId}
        {...section}
      />
    ))}
  </div>
)

export default React.memo(StateSwitcher)
